<template>
  <svg width="32" height="35" viewBox="0 0 32 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M29.1237 3.06305V21.6252H15.223L8.4996 29.0209V21.6252H2.8747V3.06305H29.1237ZM30.9992 1H1V23.6874H6.6249V34L16 23.6874H31L30.9992 1Z" stroke-width="0.5"/>
  </svg>

</template>
